// Accordion expand/collapse functionality
export function initFlyovers() {
    const flyoverItems = document.querySelectorAll('.flyover-item');

    flyoverItems.forEach((item) => {
        const trigger = item.querySelector('.flyover-trigger') as HTMLButtonElement;
        const content = item.querySelector('.flyover-content') as HTMLElement;

        if (!trigger || !content) return;

        trigger.addEventListener('click', () => {
            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

            // Close all other flyover items
            flyoverItems.forEach((otherItem) => {
                if (otherItem !== item) {
                    const otherTrigger = otherItem.querySelector('.flyover-trigger') as HTMLButtonElement;
                    const otherContent = otherItem.querySelector('.flyover-content') as HTMLElement;
                    const otherIcon = otherItem.querySelector('.flyover-icon') as HTMLElement;

                    otherTrigger?.setAttribute('aria-expanded', 'false');
                    otherContent?.classList.add('hidden');
                    otherIcon?.classList.remove('rotate-180');
                }
            });

            // Toggle current item
            trigger.setAttribute('aria-expanded', String(!isExpanded));

            if (isExpanded) {
                // Collapse
                trigger.classList.remove('grid');
                trigger.classList.add('flex');
                content.classList.add('hidden');
            } else {
                // Expand
                trigger.classList.remove('flex');
                trigger.classList.add('grid');
                content.classList.remove('hidden');
            }
        });

        // Keyboard support
        trigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                trigger.click();
            }
        });
    });

    // Close flyover when clicking outside
    document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;

        // Check if click is outside all flyover items
        const isClickInside = Array.from(flyoverItems).some(item =>
            item.contains(target)
        );

        if (!isClickInside) {
            flyoverItems.forEach((item) => {
                const trigger = item.querySelector('.flyover-trigger') as HTMLButtonElement;
                const content = item.querySelector('.flyover-content') as HTMLElement;

                if (trigger?.getAttribute('aria-expanded') === 'true') {
                    trigger.setAttribute('aria-expanded', 'false');
                    trigger.classList.remove('grid');
                    trigger.classList.add('flex');
                    content?.classList.add('hidden');
                }
            });
        }
    });

}
